import { render, staticRenderFns } from "./ResumeRenameModal.vue?vue&type=template&id=06ef73d9"
import script from "./ResumeRenameModal.vue?vue&type=script&lang=js"
export * from "./ResumeRenameModal.vue?vue&type=script&lang=js"
import style0 from "./ResumeRenameModal.vue?vue&type=style&index=0&id=06ef73d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports